import { useSelector } from "react-redux";
import "./index.scss";
export const UploadSpinner = ({ className }) => {
  const loadingText = useSelector(
    (state) => state.configurationReducer.loadingText
  );
  return (
    <div className={`.centeredDiv ${className ? className : ""}`}>
        <span class="uploadLoader"></span>
        <div className="text-center fs-10px loadingText">{loadingText}</div>
    </div>
 );
};

export default UploadSpinner;